export const CART = {
    REQUEST_ADDCART: "REQUEST_ADDCART",
    SUCCESS_ADDCART: "SUCCESS_ADDCART",
    FAILED_ADDCART: "FAILED_ADDCART",
    SUCCESS_FETCHCART: "SUCCESS_FETCHCART",
    SUCCESS_RECENTCART: "SUCCESS_RECENTCART",
    FAILED_RECENTCART: "FAILED_RECENTCART",
}